import 'unpoly'

// unpoly configuration
up.link.config.followSelectors.push('a[href]');


// import compilers
import './autofocus_compiler'
import './barcode-reader_compiler'
import './checkbox_compiler'
import './collapse_compiler'
import './device-settings_compiler'
import './event_compiler'
import './filter_compiler'
import './flash-alert_compiler'
import './put-away-spot_compiler'
import './spot-picker_compiler'
import './transfers-tabs_compiler'
import './spot-lookup_compiler'
import './material-lookup_compiler'
import './reload_compiler'
import './sidebar_compiler'
import './tom_select_compiler'
import './transfer-item-edit_compiler'
import './transfer-picking_compiler'
import './unpoly_extension_compiler'
import './warehousemanagement_compiler'

